export default function initializeNumbersBlock() {
    document.querySelectorAll('.block-numbers').forEach(function (block) {
        new NumbersBlock(block);
    });
}

class NumbersBlock {
    constructor(block) {
        this.block = block;
        this.duration = (parseFloat(block.dataset.duration) || 5) * 1000;
        this.animated = false;
        this.init();
    }

    init() {
        const observer = new IntersectionObserver((entries) => {
            entries.forEach((entry) => {
                if (entry.isIntersecting && !this.animated) {
                    this.animated = true;
                    this.startAnimation();
                    observer.unobserve(this.block);
                }
            });
        }, { threshold: 0.2 });

        observer.observe(this.block);
    }

    startAnimation() {
        this.block.querySelectorAll('.block-numbers-item__number').forEach((el) => {
            const target = parseInt(el.dataset.number, 10);
            if (isNaN(target) || target === 0) {
                el.textContent = target || 0;
                return;
            }
            this.animateValue(el, 0, target, this.duration);
        });
    }

    animateValue(el, start, end, duration) {
        const startTime = performance.now();
        const direction = end > start ? 1 : -1;
        const range = Math.abs(end - start);

        const step = (currentTime) => {
            const elapsed = currentTime - startTime;
            const progress = Math.min(elapsed / duration, 1);
            const eased = 1 - Math.pow(1 - progress, 3);
            const current = Math.round(start + range * eased * direction);

            el.textContent = current;

            if (progress < 1) {
                requestAnimationFrame(step);
            } else {
                el.textContent = end;
            }
        };

        requestAnimationFrame(step);
    }
}
